<template>
  <div class="modal-container" :class="themedClass">
    <LsClickable
      v-if="cancelable"
      :track-id="`${trackId}-close`"
      class="modal-close-x"
      @click="close"
      @mouseover="closeColor = 'gray-secondary'"
      @mouseleave="closeColor = 'primary'"
    >
      <LsIcon type="close" :color="closeColor" />
    </LsClickable>
    <header class="modal-header">
      {{ title }}
      <p v-if="subTitle">{{ subTitle }}</p>
    </header>
    <section class="modal-body"><slot name="body" /></section>
    <footer class="modal-footer"><slot name="footer" /></footer>
  </div>
</template>

<script>
import _ from 'lodash';
import { lsErrorService, lsPropTypeHelpers, lsTrackingService } from 'ls-vue-common';
import VueTypes from 'vue-types';

import { LsClickable, LsIcon } from '@/components/common';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LsModal',
  components: {
    LsClickable,
    LsIcon,
  },
  mixins: [themedComponentMixin],
  props: {
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    title: VueTypes.string.isRequired,
    subTitle: VueTypes.sting,
    cancelable: VueTypes.bool.def(true),
  },
  data() {
    return {
      closeColor: 'primary',
    };
  },
  mounted() {
    this.track({ open: true });
  },
  beforeDestroy() {
    this.track({ open: false });
    this.$parent.$emit('close');
  },
  methods: {
    track({ open }) {
      const routePath = _.get(this.$route, 'path', '');
      const referrerBasePath = `${location.protocol}//${location.host}${routePath}`;
      const kebabModalName = _.kebabCase(this.trackId);
      const modalPath = `${routePath}/modal/${kebabModalName}`;
      const modalUrl = `${referrerBasePath}/modal/${kebabModalName}`;

      const data = {
        path: open ? modalPath : routePath,
        url: open ? modalUrl : referrerBasePath,
        referrer: open ? referrerBasePath : modalUrl,
      };

      lsTrackingService.page({
        data,
      });
    },
    close() {
      if (_.isFunction(this.$parent.$parent.close)) {
        this.$parent.$emit('close');
        this.$parent.$parent.close();
      } else if (_.isFunction(this.$parent.$parent.$parent.close)) {
        // Cancellation modal utilizes nested conditional children
        // so we look another level up for the close method.
        this.$parent.$parent.$emit('close');
        this.$parent.$parent.$parent.close();
      } else {
        lsErrorService.log({
          error: {
            message: `Attempting to close modal failed`,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.themed-app {
  .modal-container {
    border-color: $theme-color-primary;

    .modal-header {
      color: $theme-color-primary;
    }
  }
}
</style>
